/** @jsxImportSource @emotion/react */
import { Modal } from "antd";
import { ReactComponent as IconLogout } from "assets/mobile/icons/logout.svg";
import MESSAGE from "constants/message";
import { PATH } from "constants/path";
import { useAppDispatch, useAppSelector } from "hooks/app-hook";
import { useAppLogout } from "hooks/useLogout";
import { useNavigate } from "react-router-dom";
import { selectIsAuthenticated } from "store/auth";
import { selectOpenSidebar, setOpenSidebar } from "store/master";
import { selectProfile } from "store/user";

import AutoTime from "./AutoTime";
import { SidebarStyle } from "./index.style";
import { menuItemsSidebar } from "./list-menu";

function Sidebar() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const openSidebar = useAppSelector(selectOpenSidebar);
  const isAuth = useAppSelector(selectIsAuthenticated);
  const profile = useAppSelector(selectProfile);
  const onLogout = useAppLogout();
  const [modal, contextHolder] = Modal.useModal();

  const confirmLogout = () => {
    modal.confirm({
      title: MESSAGE.notification,
      icon: null,
      content: MESSAGE.logout.title,
      okText: MESSAGE.confirm,
      cancelText: MESSAGE.cancel,
      centered: true,
      className: "non-reset",
      onOk: handleConfirm,
      onCancel: () => {
        //
      },
    });
  };

  const handleConfirm = () => {
    onLogout();
    dispatch(setOpenSidebar(false));
  };
  return (
    <>
      {contextHolder}
      <div css={SidebarStyle.index(openSidebar)}>
        <div css={SidebarStyle.content}>
          <div css={SidebarStyle.header}>
            <span
              onClick={() => dispatch(setOpenSidebar(false))}
              css={SidebarStyle.close}
            >
              X
            </span>
            {isAuth ? (
              <div css={SidebarStyle.info}>
                <span className="username">Xin chào, {profile?.username}</span>
              </div>
            ) : (
              <>
                <button
                  onClick={() => {
                    navigate(PATH.Account.login);
                    dispatch(setOpenSidebar(false));
                  }}
                >
                  ĐĂNG NHẬP
                </button>
                <button
                  onClick={() => {
                    navigate(PATH.Account.register);
                    dispatch(setOpenSidebar(false));
                  }}
                >
                  ĐĂNG KÝ
                </button>
              </>
            )}
            <AutoTime />
          </div>
          <div css={SidebarStyle.menus}>
            {menuItemsSidebar.map((item, index) => {
              return (
                <div
                  onClick={() => {
                    if (item.isOpen) {
                      window.open(item.link);
                    } else {
                      navigate(item.link);
                    }
                    dispatch(setOpenSidebar(false));
                  }}
                  key={index}
                  css={SidebarStyle.itemMenu}
                >
                  <item.icon fill={item.color} />
                  <span>{item.name}</span>
                </div>
              );
            })}
          </div>
          {isAuth && (
            <div css={SidebarStyle.menus}>
              <div css={SidebarStyle.itemMenu}>
                <IconLogout />
                <span onClick={confirmLogout}>Đăng xuất</span>
              </div>
            </div>
          )}
        </div>
      </div>
      {openSidebar && (
        <div
          onClick={() => dispatch(setOpenSidebar(false))}
          css={SidebarStyle.overlay}
        />
      )}
    </>
  );
}

export default Sidebar;
